import React, { useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Function to handle scrolling
    const handleScroll = () => {
        // Set isVisible to true if user has scrolled down, false otherwise
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Function to scroll back to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Add event listener to window scroll
    // This will trigger handleScroll function when user scrolls
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <button
            onClick={scrollToTop}
            className={`bg-primary-color hover:bg-secondary-color rounded-full p-4 fixed bottom-4 right-4 md:bottom-8 md:right-8 z-10 transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
                }`}
        >
            <FaChevronUp className="text-2xl text-white transform transition-transform hover:scale-110 " />
        </button>
    );
};

export default ScrollToTopButton;
